import moment from 'moment';

export function createQuotedEmailTextPlain(emailItem) {
  if (emailItem.content.bodyPlain) {
    let responseHeader = `On ${moment(emailItem.timestamp).format('dddd, MMMM D, YYYY, h:mm A')} ${
      emailItem.content.from
    } wrote:`;

    return `${responseHeader}\r\n\r\n${emailItem.content.bodyPlain
      .split(/\r?\n/)
      .map(line => `> ${line}\r\n`)
      .join('')}`;
  }

  return null;
}

export const BLOCKQUOTE_STYLE = 'margin:0 0 0 .8ex;border-left:1px #ccc solid;padding-left:1ex';
export function createQuotedEmailTextHtml(emailItem) {
  let quotedText = emailItem.content.bodyHtml;
  if (!quotedText && emailItem.content.bodyPlain) {
    quotedText = `<div>${emailItem.content.bodyPlain.replace(/(\r\n|\n|\r)/g, '<br>')}</div>`;
  }
  if (quotedText) {
    let sanitizedQuotedText = removeHtmlTag(quotedText);
    return `<div><br><div>On ${moment(emailItem.timestamp).format(
      'dddd, MMMM D, YYYY, h:mm A'
    )} ${htmlEscapeFromAddress(
      emailItem.content.from
    )} wrote:<br><blockquote style="${BLOCKQUOTE_STYLE}">${sanitizedQuotedText}</blockquote></div><br></div>`;
  }

  return null;
}

/*
 The email that is quoted might contain a <html> and/or <body> tags. 
 This might cause problems with receiving email client where they can not correctly render email. 
*/
function removeHtmlTag(htmlContent) {
  let container = document.createElement('div');
  container.innerHTML = htmlContent;
  return container.innerHTML;
}

/*
  The fromAddress will often be formatted as "John Smith" <jsmith@example.com>.
  We need to escape the characters in order for them to get rendered in the HTML email.
*/
function htmlEscapeFromAddress(fromAddress = '') {
  return fromAddress
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composition/lib/create_quoted_email_text.js